  import {
  AppBar,
  Box,
  IconButton,
  Skeleton,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { MenuOpenRounded, MenuRounded } from "components/common";
import { drawerWidth } from "config";

import { useEffect } from "react";
import useAnyModalOpen from "../ts/useAnyModalOpen";
import useFunctions from "../ts/useFunctions";

export default function Header() {
  const theme = useTheme();
  const isTemporary = useMediaQuery(theme.breakpoints.down("lg"));
  const isAnyModalOpen = useAnyModalOpen();
  const {
    open,
    handleDrawerToggle,
    getUser,
    admin,
    loader,
    getRandomGreeting,
  } = useFunctions();

  useEffect(() => {
    getUser();
  }, [getUser]);

  return (
    <AppBar
      sx={{
        display: {
          xs: isTemporary && (open || isAnyModalOpen) ? "none" : "flex",
          lg: "flex",
        },
        zIndex: { xs: 1401, lg: 10 },
        height: "70px",
        width: {
          xs: "100%",
          lg: open ? `calc(100% - ${drawerWidth}px)` : `calc(100% - 85px)`,
        },
        marginLeft: { xs: 0, lg: open ? `${drawerWidth}px` : "auto" },
        transitionProperty: "all",
        transitionDuration: "225ms",
        TransitionTimingFunction: "cubic-bezier(0.4,0,0.6,1)",
      }}
      className="sticky"
      position="fixed"
      elevation={0}
    >
      <Toolbar
        sx={{
          height: "100%",
          justifyContent: "space-between",
        }}
      >
        <IconButton
          disableRipple
          aria-label="open drawer"
          onClick={handleDrawerToggle}
          edge="start"
          color="secondary"
          sx={{
            display: {
              xs: isTemporary && (open || isAnyModalOpen) ? "none" : "inline-flex",
              lg: "inline-flex",
            },
            ml: { xs: 0, lg: -2 },
            transitionProperty: "all",
            transitionDuration: "225ms",
            TransitionTimingFunction: "cubic-bezier(0.4,0,0.6,1)",
          }}
        >
          {!open || isTemporary ? (
            <MenuRounded
              sx={{
                color: "#747474",
              }}
            />
          ) : (
            <MenuOpenRounded
              className="!text-boulder"
              sx={{
                color: "#747474",
              }}
            />
          )}
        </IconButton>
        <Box
          display={{ xs: "none", sm: "flex" }}
          gap={3}
          alignItems={"center"}
        >
          {loader ? (
            <Typography variant="h6" sx={{ display: "flex" }}>
              <Skeleton
                component="span"
                width="50px"
                variant="rounded"
                sx={{ bgcolor: "primary.main" }}
              />
              ,&nbsp;
              <Skeleton
                component="span"
                width="200px"
                variant="rounded"
                sx={{ bgcolor: "gray" }}
              />
            </Typography>
          ) : (
            <Typography variant="h6">
              <Typography variant="h6" component="span" color="primary.main">
                {admin.name},&nbsp;
              </Typography>
              {getRandomGreeting()}
            </Typography>
          )}
          {/* <CustomInput
            placeholder="Search"
            InputProps={{ startAdornment: <SearchRounded /> }}
            margin="none"
          /> */}
          {/* <Box display={"flex"} gap={1} alignItems={"center"}>
            <CustomIconButton>
              <AlarmOnRounded
                sx={{
                  width: "25px",
                  height: "25px",
                }}
              />
            </CustomIconButton>
            <CustomIconButton>
              <CalendarMonthRounded
                sx={{
                  width: "25px",
                  height: "25px",
                }}
              />
            </CustomIconButton>
            <CustomIconButton>
              <Avatar
                sx={{
                  width: "40px",
                  height: "40px",
                }}
              />
            </CustomIconButton>
          </Box> */}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
